/**
 * read-route.ts uçlarını çağırır (sayfa açıkken kendiliğinden çalışan okumalar).
 * Server action yerine fetch: action yanıtı sayfayı yenileyip yeniden mount ettiği
 * için açık panel/popup'lar kapanıyordu. 2xx dışı yanıtta hata fırlatır.
 */
export async function getReadRoute<T>(url: string): Promise<T> {
  const response = await fetch(url, { cache: 'no-store' })
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: unknown } | null
    throw new Error(typeof body?.error === 'string' ? body.error : `Okuma isteği başarısız (${response.status})`)
  }
  return (await response.json()) as T
}
